import {v4 as uuid} from 'uuid';

/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
  {
    _id: uuid(),
    name: 'Onion',
    quantity: '1000',
    quantityUnit: 'gram',
    price: 25,
    categoryName: 'Vegetables',
    rating: 4.6,
    image: 'https://farmersfz.com/assets/public/vegimg/BGON8.jpg',
    discount: 25,
    shelfLife: '7 Days',
    packageWith: 'Keep in loose,open space.',
  },
  {
    _id: uuid(),
    name: 'Tomato',
    quantityUnit: 'gram',
    quantity: '500',
    price: 16,
    categoryName: 'Vegetables',
    rating: 3.7,
    image: 'https://m.media-amazon.com/images/I/4109t2-iaPL._SX425_.jpg',
    discount: 25,
    shelfLife: '10 Days',
    packageWith:
      'Raw tomatoes should be kept in room temperature. If ripe they should be refrigerated',
  },
  {
    _id: uuid(),
    name: 'Lady Finger',
    quantityUnit: 'gram',
    quantity: '250',
    price: 15,
    categoryName: 'Vegetables',
    rating: 4.7,
    image: 'https://cdn.shopify.com/s/files/1/0244/4961/3905/products/okra.jpg?v=1576806732',
    discount: 30,
    shelfLife: '6 Days',
    packageWith: 'Plastic Bag with holes',
  },
  {
    _id: uuid(),
    name: 'Green Chillies',
    quantityUnit: 'gram',
    quantity: '100',
    price: 15,
    categoryName: 'Vegetables',
    rating: 3.4,
    discount: 30,
    packageWith: 'Refrigerate and Plastic Bag with holes',
    shelfLife: '6 Days',
    image:
      'https://cdn.shopify.com/s/files/1/0104/1059/0266/products/Organic-Green-Chilli_large_large_4410288b-ff46-4d7d-8e6b-f9c5775a0d27.jpg?v=1571986449',
  },
  {
    _id: uuid(),
    name: 'Organic Spinach / Palak',
    quantityUnit: 'unit',
    quantity: '1',
    price: 44,
    categoryName: 'Vegetables',
    rating: 2.6,
    description: 'Cleaned and Packed without roots.',
    shelfLife: '3 Days',
    packageWith: 'Roll in a Paper Towel',
    image:
      'https://5.imimg.com/data5/PI/KX/MY-46595757/fresh-spinach-28palak-29-281kg-29-500x500.png',
    discount: 22,
  },

  {
    _id: uuid(),
    name: 'Banana',
    quantityUnit: 'gram',
    quantity: '500',
    price: 31,
    categoryName: 'Fruits',
    rating: 2.3,
    discount: 25,
    shelfLife: '4 days',
    packageWith: 'Keep it Loose',
    image:
      'https://media.istockphoto.com/id/173242750/photo/banana-bunch.jpg?s=612x612&w=0&k=20&c=MAc8AXVz5KxwWeEmh75WwH6j_HouRczBFAhulLAtRUU=',
  },
  {
    _id: uuid(),
    name: 'Pomogranates',
    quantityUnit: 'gram',
    quantity: '500',
    price: 31,
    categoryName: 'Fruits',
    rating: 1.3,
    discount: 10,
    shelfLife: '6-7 days',
    packageWith: 'keep it loose',
    image:
      'https://images.healthshots.com/healthshots/en/uploads/2021/09/27184641/pomegranate-1600x900.jpg',
  },
  {
    _id: uuid(),
    name: 'Coconut',
    quantityUnit: 'unit',
    quantity: '1',
    price: 47,
    categoryName: 'Fruits',
    rating: 2.6,
    discount: 5,
    shelfLife: '3 days',
    packageWith: 'Keep it Loose.',
    image: 'https://kumaribasket.com/wp-content/uploads/2021/01/Tender-Coconut2.jpg',
  },
  {
    _id: uuid(),
    name: 'Guava',
    quantityUnit: 'gram',
    quantity: '500',
    price: 64,
    categoryName: 'Fruits',
    rating: 1.6,
    discount: 10,
    shelfLife: '6-7days',
    packageWith: 'Keep it Loose.IF riped then Refrigerate.',
    image:
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTAy71WRIKR0JMdAkldQJILTxBl1VaACAAsWw&usqp=CAU',
  },
  {
    _id: uuid(),
    name: 'Kesar Mangoes',
    quantityUnit: 'gram',
    quantity: '500',
    price: 80,
    categoryName: 'Fruits',
    rating: 4.9,
    discount: 20,
    shelfLife: '10-11days',
    packageWith: 'Keep it Loose',
    image:
      'https://images.ctfassets.net/5djn6ve9uecf/5Avz4k2vOTFbphDuUTcQm7/eee72c2cc2e043b8a430268b46e5c3c2/Kesar_shutterstock_1708900531_copy.jpg',
  },

  // all bakery products are in gram
  {
    _id: uuid(),
    name: 'Bread - Brown',
    quantityUnit: 'gram',
    quantity: '400',
    price: 55,
    categoryName: 'Bakery and Biscuits',
    rating: 1.5,
    discount: 5,
    shelfLife: '2days',
    packageWith: '',
    image:
      'https://cdn.shopify.com/s/files/1/0279/6329/3831/products/brown_bread_6faa3679-7906-49ce-899f-dff72ba56ff5_grande.jpg?v=1600680069',
  },
  {
    _id: uuid(),
    name: 'White Sandwich Bread',
    quantityUnit: 'gram',
    quantity: '400',
    price: 50,
    categoryName: 'Bakery and Biscuits',
    rating: 3.2,
    discount: 5,
    shelfLife: '2days',
    packageWith: '',
    image: 'https://www.goldmedalbakery.com/content/uploads/2019/12/Sandwich-White.jpg',
  },
  {
    _id: uuid(),
    name: 'Crozzo Assorted Croissants Pack Of 2',
    quantityUnit: 'unit',
    quantity: '1',
    price: 229,
    categoryName: 'Bakery and Biscuits',
    rating: 2.8,
    discount: 5,
    shelfLife: 'As mentioned on Packet',
    packageWith: '',
    image:
      'https://cdn.shopify.com/s/files/1/0511/2158/6327/products/AssortedCroissantBox1_1024x.jpg?v=1644310793',
  },
  {
    _id: uuid(),
    name: 'Multigrain Sandwich Bread',
    quantityUnit: 'gram',
    quantity: '150',
    price: 70,
    categoryName: 'Bakery and Biscuits',
    rating: 3.7,
    discount: 5,
    shelfLife: 'As mentioned on Packet.',
    packageWith: '',
    image:
      'https://www.kingarthurbaking.com/sites/default/files/styles/featured_image/public/recipe_legacy/9027-3-large.jpg?itok=cYIGvAGS',
  },
  {
    _id: uuid(),
    name: 'Brownie Cottage Pure Hot Fudge',
    quantityUnit: 'unit',
    quantity: '1',
    price: 230,
    categoryName: 'Bakery and Biscuits',
    rating: 2.5,
    discount: 5,
    shelfLife: 'As mentioned on packet.',
    packageWith: '',
    image:
      'https://d1z88p83zuviay.cloudfront.net/ProductVariantImages/3c95f219-2ccc-47fa-817f-bdb948cb574f.jpg',
  },

  {
    _id: uuid(),
    name: 'Almonds',
    quantityUnit: 'gram',
    quantity: '200',
    price: 181,
    categoryName: 'Dry-Fruits',
    rating: 3.5,
    image: 'https://m.media-amazon.com/images/I/51ODBfoqozL.jpg',
    discount: 32,
    shelfLife: '',
    packageWith: '',
  },
  {
    _id: uuid(),
    name: 'Cashews',
    quantityUnit: 'gram',
    quantity: '200',
    price: 210,
    categoryName: 'Dry-Fruits',
    rating: 2.8,
    image: 'https://dspices.in/image/cache/catalog/products/cashew/cw_1-800x800.jpg',
    discount: 35,
    shelfLife: '',
    packageWith: '',
  },
  {
    _id: uuid(),
    name: 'Raisins',
    quantityUnit: 'gram',
    quantity: '200',
    price: 62,
    categoryName: 'Dry-Fruits',
    rating: 2.5,
    image: 'https://www.dryfruitshome.com/wp-content/uploads/2020/10/munakka.jpg',
    discount: 30,
    shelfLife: '',
    packageWith: '',
  },
  {
    _id: uuid(),
    name: 'Salted Pistachios',
    quantityUnit: 'gram',
    quantity: '200',
    price: 272,
    categoryName: 'Dry-Fruits',
    rating: 2.8,
    image: 'https://indiacuisine.net/cdn/shop/products/PISTA.jpg?v=1615638822',
    discount: 40,
    shelfLife: '',
    packageWith: '',
  },
  {
    _id: uuid(),
    name: 'Mix Berries',
    quantityUnit: 'gram',
    quantity: '200',
    price: 365,
    categoryName: 'Dry-Fruits',
    rating: 1.3,
    image: 'https://m.media-amazon.com/images/I/51h1HtbZYWL.jpg',
    discount: 35,
    shelfLife: '',
    packageWith: '',
  },

  {
    _id: uuid(),
    name: 'Full Cream Fresh Milk ',
    quantityUnit: 'ml',
    quantity: '500',
    price: 33,
    categoryName: 'Dairy',
    rating: 1.9,
    image: 'https://foodsguy.com/wp-content/uploads/2022/04/Milk.jpg',
    discount: 5,
    shelfLife: '2 Days',
    packageWith: '',
  },
  {
    _id: uuid(),
    name: 'Cheese Slices',
    quantityUnit: 'gram',
    quantity: '200',
    price: 138,
    categoryName: 'Dairy',
    rating: 2.6,
    image: 'https://gourmet-foods.in/wp-content/uploads/2021/07/sliced-cheese-500x500-1.jpg',
    discount: 15,
    shelfLife: '',
    packageWith: '',
  },
  {
    _id: uuid(),
    name: 'Fresh Malai Paneer',
    quantityUnit: 'gram',
    quantity: '200',
    price: 91,
    categoryName: 'Dairy',
    rating: 3.6,
    image:
      'https://5.imimg.com/data5/ANDROID/Default/2022/10/GI/MP/QC/100746515/product-jpeg-500x500.jpg',
    discount: 15,
    shelfLife: '',
    packageWith: '',
  },
  {
    _id: uuid(),
    name: 'Salted Butter',
    quantityUnit: 'gram',
    quantity: '200',
    price: 114,
    categoryName: 'Dairy',
    rating: 4.3,
    discount: 20,
    shelfLife: '',
    packageWith: '',
    image:
      'https://www.southernliving.com/thmb/S3jnGzbVG4VUSMFqU-Ohjw3pdFE=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/butter_cutting_board-179875636-2000-14b4ec54a0a64d2f8c884822acb68415.jpg',
  },
  {
    _id: uuid(),
    name: 'Spiced Buttermilk',
    quantityUnit: 'ml',
    quantity: '500',
    price: 22,
    categoryName: 'Dairy',
    rating: 1.3,
    discount: 5,
    shelfLife: '',
    packageWith: '',
    image:
      'https://static.wixstatic.com/media/cdf1d3_a7c86a153904481faa5bde2eb5b1f88b~mv2.jpg/v1/fill/w_601,h_600,al_c,q_85/cdf1d3_a7c86a153904481faa5bde2eb5b1f88b~mv2.jpg',
  },
  {
    _id: uuid(),
    name: 'Healthy Daily Eggs',
    quantityUnit: 'pcs',
    quantity: '6',
    price: 90,
    categoryName: 'Eggs-Meat-Fish',
    rating: 2.3,
    discount: 13,
    shelfLife: '3-5 weeks',
    packageWith: 'Refrigerate',
    image: 'https://www.netojin.com/wp-content/uploads/2022/02/egg.jpg',
  },
  {
    _id: uuid(),
    name: 'Healthy Brown Eggs',
    quantityUnit: 'pcs',
    quantity: '6',
    price: 90,
    categoryName: 'Eggs-Meat-Fish',
    rating: 2.4,
    discount: 13,
    shelfLife: '3-5 weeks',
    packageWith: 'Refrigerate',
    image:
      'https://cdn3.mydukaan.io/app/image/1000x1000/?url=https://projecteagle.s3.ap-south-1.amazonaws.com/images/9fe6f688-d136-4b98-a531-7a1d5084fffd.jpg',
  },
  {
    _id: uuid(),
    name: 'Fronzen Prawns Small',
    quantityUnit: 'gram',
    quantity: '250',
    price: 250,
    categoryName: 'Eggs-Meat-Fish',
    rating: 2.4,
    discount: 9,
    shelfLife: 'As mentioned on packet',
    packageWith: 'Refrigerate',
    image: 'https://www.bigbasket.com/media/uploads/p/l/40186082_5-fresho-frozen-prawns-small.jpg',
  },
  {
    _id: uuid(),
    name: 'Canned Tuna Chunks in Tomato Sauce',
    quantityUnit: 'gram',
    quantity: '185',
    price: 215,
    categoryName: 'Eggs-Meat-Fish',
    rating: 4.1,
    discount: 15,
    shelfLife: 'As mentioned on packet',
    packageWith: 'Refrigerate',
    image: 'https://m.media-amazon.com/images/I/8160JPPTFBL.jpg',
  },
  {
    _id: uuid(),
    name: 'Premium Mutton Cubes',
    quantityUnit: 'gram',
    quantity: '450',
    price: 675,
    categoryName: 'Eggs-Meat-Fish',
    rating: 2.4,
    discount: 10,
    shelfLife: 'As mentioned on packet',
    packageWith: 'Refrigerate',
    image: 'https://totalfoods.in/static/uploads/complaint_image/image_5qPyy8o.jpg',
  },
];
